import React, { useState } from "react";
import "firebase/firestore";
import "firebase/auth";
import { Col, Modal, Row } from "reactstrap";
import "firebase/storage";
import "firebase/firestore";

const GalleryForm = ({ isAdmin }) => {
  const [modal, setModal] = useState(false);
  const [loading] = useState(false);
  const [index, setIndex] = useState(0);
  const [images] = useState([]);
  const [isEdit] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div>
        <Modal centered={true} size="md" isOpen={modal} toggle={toggle}>
          <i onClick={toggle} className="fas fa-times modal-icon text-white" />
          {!!images && !!images.length && (
            <img src={images[index].imagen} alt="agendar_jornada" />
          )}
        </Modal>
      </div>

      {!!isAdmin ? (
        <div className="container">
          <Row>
            <Col lg="4" className="shadow p-3 mb-5 bg-white rounded mt-5">
              <div className="d-flex justify-content-center mb-3">
                <img
                  width="100"
                  height="auto"
                  alt="Logo"
                  src="/images/custom/logo.png"
                />
              </div>
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="text-muted text-center mb-3">
                      {!isEdit ? "Añadir Imagen" : "Editar Imagen"}
                    </h2>
                    <div className="form-group">
                      <input
                        type="file"
                        className="form-control"
                        
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary btn-block"
                      >
                        {!!loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span className="sr-only">Loading...</span>
                            {!isEdit ? "Añadiendo Imagen" : "Editando Imagen"}
                          </>
                        ) : (
                          <div>
                            {!isEdit ? "Añadir Imagen" : "Editar Imagen"}
                          </div>
                        )}
                      </button>
                      <button
                        className="btn btn-sm btn-dark btn-block"
                        onClick={(e) => {
                          window.location.href = "/";
                          e.stopPropagation();
                        }}
                      >
                        Volver
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </Col>

            <Col
              lg="8"
              className="mt-5"
              style={{ height: 350, overflowY: "auto" }}
            >
              <table className="table table-hover">
                <thead className="thead-dark text-center">
                  <tr>
                    <th>Imagen</th>
                    <th>Acción</th>
                  </tr>
                </thead>

                <tbody className="text-center">
                  {!!images &&
                    images.length > 0 &&
                    images.map((imagen, index) => {
                      return (
                        <tr key={imagen.id}>
                          <td>
                            <i
                              className="fas fa-images image-icon"
                              
                            />
                          </td>
                          <td>
                            <i
                              className="fas fa-edit mr-3 image-icon-edit"
                              
                            />
                            <i
                              className="fas fa-trash-alt image-icon-delete"
                              
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      ) : (
        <div />
      )}
    </>
  );
};

export default GalleryForm;
